package one.healthium.base.utils

import kotlin.math.absoluteValue
import kotlin.math.pow
import kotlin.math.roundToInt
import loco.GENERAL_WEIGHT_KG_FORMAT
import loco.GENERAL_WEIGHT_LB_FORMAT
import one.healthium.loco.LString
import one.healthium.loco.asLString

const val ftFactor = 30.48f
const val lbFactor = 2.20462f
const val ozFactor = 33.814f

fun Float.cmToFt(): Float {
    return this / ftFactor
}

fun Float.ftToIn(): Int {
    return (this * 12).roundToInt()
}

fun Int.inToFt(): Float {
    return this / 12f
}

fun Float.toMeters(): Float {
    return this / 100f
}

fun Float.toCm(): Float {
    return this * ftFactor
}

fun Float.kgToLb(): Float {
    return this * lbFactor
}

fun Float.lbToKg(): Float {
    return this / lbFactor
}

fun Float.litresToOz() = this * ozFactor
fun Float.ozToLitres() = this / ozFactor

fun Float.toVolumeString(isMetric: Boolean): String {
    return if (isMetric) this.toString(2) else this.litresToOz().toString(2)
}

fun Float.toWeightString(isMetric: Boolean): String {
    return if (isMetric) this.toString(1) else this.kgToLb().toString(1)
}

@Deprecated("use Formatters.formatWeight")
fun Float.toWeightAndUnitString(isMetric: Boolean): LString {
    val value = this.toString(1)
    return if (isMetric) {
        loco.Res.string.GENERAL_WEIGHT_KG_FORMAT.asLString(value)
    } else {
        loco.Res.string.GENERAL_WEIGHT_LB_FORMAT.asLString(value)
    }
}

fun Float.toHeightString(isMetric: Boolean): String {
    return if (isMetric) this.roundToInt().toString() else this.cmToFt().toString(1)
}

fun Float.toString(numOfDec: Int): String {
    val integerDigits = this.toInt()
    val floatDigits = ((this - integerDigits) * 10f.pow(numOfDec)).roundToInt().absoluteValue
    return if (floatDigits != 0) {
        "${integerDigits}.${floatDigits}".trimEnd('0')
    } else {
        integerDigits.toString()
    }
}

fun Int?.toStringOrEmpty(): String = if (this == null || this == 0) "" else toString()

fun Float.divSafe(value: Float): Float {
    return if (value == 0f) 0f else div(value)
}

fun Float?.orZero() = this ?: 0f